import { render, staticRenderFns } from "./bind_list.vue?vue&type=template&id=433bf3e7&scoped=true&"
import script from "./bind_list.vue?vue&type=script&lang=js&"
export * from "./bind_list.vue?vue&type=script&lang=js&"
import style0 from "./bind_list.vue?vue&type=style&index=0&id=433bf3e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433bf3e7",
  null
  
)

export default component.exports